import React, { useState, useEffect } from "react";
import "./order/OrderUser.css";
import "./Auth.css"
import {useNavigate, useLocation, Link} from "react-router-dom";
import httpService from "../services/HttpService";
import Header from "./common/Header";

const Auth = ({ nextPage = "/home", isRegisterPage = false, title = "Войти" }) => {
    const [phone, setPhone] = useState("+7");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [smsCode, setSmsCode] = useState("");
    const [timer, setTimer] = useState(30);
    const [errors, setErrors] = useState({ name: false, phone: false, sms: false });
    const [isRegister, setIsRegister] = useState(isRegisterPage);
    const navigate = useNavigate();

    useEffect(() => {
        let countdown;
        if (isModalOpen && timer > 0) {
            countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        }
        return () => clearInterval(countdown);
    }, [isModalOpen, timer]);

    const handlePhoneInputChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        if (value === "") {
            setPhone("+7");
            return;
        }
        if (value.length > 11) value = value.slice(0, 11);

        let formattedValue = "+7";
        if (value.length > 1) formattedValue += " (" + value.slice(1, 4);
        if (value.length > 4) formattedValue += ") " + value.slice(4, 7);
        if (value.length > 7) formattedValue += "-" + value.slice(7, 9);
        if (value.length > 9) formattedValue += "-" + value.slice(9, 11);

        setPhone(formattedValue);
    };

    const handleContinueClick = async () => {
        let validationErrors = { name: false, phone: false, sms: false };
        if (!phone || phone === "+7") validationErrors.phone = true;

        const nameInput = document.querySelector('input[placeholder="Имя"]');
        if (isRegister && !nameInput?.value) validationErrors.name = true;

        setErrors(validationErrors);

        if (!validationErrors.name && !validationErrors.phone) {
            try {
                let response;
                if (isRegister) {
                    response = await httpService.post("/register", {
                        phone,
                        first_name: nameInput?.value,
                    });
                } else {
                    response = await httpService.post("/login", { phone });
                }        
                const res = await response.json(); 

                if (res?.spam === true || res?.status === true) {
                    setIsModalOpen(true);
                    setTimer(30);
                    return;
                }

                if (res?.status === false) {
                    setIsRegister(true);
                }

            } catch (error) {
                console.error("Auth error", error);
            }
        }
    };


    const closeModal = async () => {
        if (!smsCode) {
            setErrors((prevErrors) => ({ ...prevErrors, sms: true }));
            return;
        }

        try {
            // Send the verify-token request when the user clicks on the button in the modal
            const verifyResponse = await httpService
                .post("/verify-code", {
                    phone,
                    code: smsCode, // Assuming the smsCode is collected from the input field
                })
                .then(response => response.json());


            if (verifyResponse.auth_token) {
                // Token verification successful, handle the tokens
                localStorage.removeItem("client_token"); // Remove client_token
                localStorage.setItem("auth_token", verifyResponse.auth_token); // Save auth_token

                // Close the modal and navigate
                setIsModalOpen(false);
                navigate(nextPage); // Navigate to the final page after successful verification
            } else {
                // Handle failed verification (optional)
                setErrors((prevErrors) => ({ ...prevErrors, sms: true }));
            }
        } catch (error) {
            console.error("Token verification error", error);
        }
    };


    return (
        <>
            <Header />
            <div className="ou-page">
                <div className="ou-form">
                    <div className="ou-title">{title}</div>
                    <form>
                        {isRegister && (
                            <input
                                type="text"
                                placeholder="Имя"
                                className={`ou-input-field ${errors.name ? 'error' : ''}`}
                                autoComplete="name"
                            />
                        )}
                        <input
                            type="tel"
                            placeholder="Номер телефона"
                            className={`ou-input-field ${errors.phone ? 'error' : ''}`}
                            value={phone}
                            onChange={handlePhoneInputChange}
                            maxLength="18"
                            autoComplete="tel"
                            inputMode="numeric"
                        />
                    </form>
                </div>
                <button type="button" className="default-button" onClick={handleContinueClick}>
                    {isRegister ? "Зарегистрироваться" : "Продолжить"}
                </button>
                <p className="sms-timer">
                    Нажимая на кнопку {isRegister ? "Зарегистрироваться" : "Продолжить"} вы соглашаетесь с &nbsp;
                    <a
                        className="auth-privacy-link"
                        href="/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >политикой обработки персональных данных
                    </a>
                </p>
            </div>

            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <button
                            className="hamburger close"
                            onClick={() => setIsModalOpen(false)}
                            aria-label="Toggle Modal"
                        >
                            <span className="material-symbols-sharp">
                                close
                            </span>
                        </button>
                        <p>Введите SMS-код</p>
                        <input
                            type="text"
                            placeholder="SMS-код"
                            className={`ou-input-field sms-input ${errors.sms ? 'error' : ''}`}
                            value={smsCode}
                            onChange={(e) => setSmsCode(e.target.value.replace(/\D/g, "").slice(0, 4))}
                            maxLength="5"
                            autoComplete="one-time-code"
                            autoFocus
                            inputMode="numeric"
                        />
                        <p className="sms-timer">
                            {timer > 0 ? `Повторная отправка через ${timer} секунд` :
                                <span style={{cursor: 'pointer', color: 'black'}} onClick={handleContinueClick}>Запросить код повторно.</span>}
                        </p>
                        <button onClick={closeModal} className="default-button">Подтвердить</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Auth;